import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextSportsHeader, {
  SportsHeaderContextType,
} from '@contexts/sportsHeader'
import { VerticalRankingProps } from '@widgets/Teaser/sportsHeader/types'
import VerticalRankingItem from './RankingItem'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { ViewportTypeValues } from '@contexts/viewport'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledVerticalRanking = Pick<SportsHeaderContextType, 'teaserFlex'>

const { SportsHeaderContext } = contextSportsHeader

const StyledVerticalRanking = styled.div<StyledVerticalRanking>`
  ${({ teaserFlex }) => {
    let gridColumnGapDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '2') {
      gridColumnGapDesktop = `${0.025 * teaserWidthDesktop}px`
    }

    return css`
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) auto;
      width: 100%;
      box-sizing: border-box;
      padding: 6px;
      ${desktopCSS(css`
        ${desktopTeaserFlex === '2'
          ? css`
              grid-column-gap: ${gridColumnGapDesktop};
            `
          : css`
              display: none;
            `}
      `)}

      ${tabletCSS(css`
        display: none;
      `)}

      ${mobileCSS(css`
        grid-column-gap: 2.134vw;
      `)}
    `
  }}
`

const VerticalRanking: FunctionComponent<VerticalRankingProps> = ({
  competitors,
}) => {
  const { teaserFlex } = useContext(SportsHeaderContext)

  return (
    <StyledVerticalRanking teaserFlex={teaserFlex}>
      {competitors.map((competitor) => (
        <VerticalRankingItem key={competitor.name} competitor={competitor} />
      ))}
    </StyledVerticalRanking>
  )
}

export default VerticalRanking
